import { type PaginationDataInterface, useSession, UserType } from '@nextgen-web-framework/all';
import type { NextgenApiError } from '@nextgen-web-framework/core';
import { ErrorResponse, Product } from '../services';

export const debounce = (() => {
  let timeout: NodeJS.Timeout;
  return (delay: number, callback: Function) => {
    if (timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(() => {
      callback();
    }, delay);
  };
})();

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
export const formatDate = (date: string | Date | undefined) => {
  if (date) {
    const _date = new Date(date);
    return `${_date.getDate()} ${months[_date.getMonth()]}, ${_date.getFullYear()}`;
  }
  return undefined;
};

export const formatTime = (date: string | Date | undefined) => {
  if (date) {
    const _date = new Date(date);
    const withPrefixZero = (num: number) => (num < 10 ? `0${num}` : num);
    return `${withPrefixZero(_date.getHours())}:${withPrefixZero(_date.getMinutes())}:${withPrefixZero(
      _date.getSeconds(),
    )}`;
  }
  return undefined;
};

export const formatPagiationInfo = (pageObject: PaginationDataInterface, paginationText: string) => {
  const { recordStartIndex, recordEndIndex, totalRecords } = pageObject;
  return paginationText
    .replace('{{page}}', `${recordStartIndex} - ${recordEndIndex}`)
    .replace('{{total}}', `${totalRecords}`);
};

export const getPrice = (product: Product, { session, isMember, isAnonymous }: ReturnType<typeof useSession>) => {
  const prices = product.items?.[0]?.prices;
  // For MEMBER user, userSegment value is BUSINESS_OWNER
  const userType = isMember() ? UserType.ABO : session.type;
  let price = prices?.find(({ userSegment }) => userSegment === userType);
  if (!price || isAnonymous()) {
    price = prices?.[0];
  }
  return price?.priceIncludingTax;
};

export const getSynonymGroupErrors = (e: unknown) => {
  let message = ((e as NextgenApiError)?.responseBody as ErrorResponse)?.subDetails?.[0]?.message;
  if (message) {
    message = message.match(/\[.*\]/)?.[0]?.replace(/\[|\]/g, '');
    return message?.split(',');
  }
  return undefined;
};
